export default function({ state, commit, dispatch }, query) {
    
    commit('startFilterPatient', query)

}
